import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=aa229f4c&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resource.vue?vue&type=style&index=1&id=aa229f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa229f4c",
  null
  
)

export default component.exports